import React, { useEffect, useState } from "react";
import axios from "axios";
import configData from "../config.json";
import { Footer, Navbar } from "../adminComponents";

const AddProducts = () => {

  const [view, setView] = useState("list"); // list | form
  const [products, setProducts] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [categories,setCategories]=useState([]);
  const [subcategories,setSubcategories]=useState([]);
  const [productImage,setProductImage]=useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    ProductName: "",
    proSize: "",
    category: "",
    CategoryID:"",
    subCategory: "",
    ProductPrice: "",
    mUnit: "",
    UnitsInStock: 0,
    Description: "",
    ManufactureYear: "",
    origin: "",
    ColorCode: "",
    Feature:"",
    Image:"",
    status:"A"
  });

  const units = ["Pcs", "M.Ton", "Meter", "Coil", "Kg"];

  // 📦 Load products
  const loadProducts = async () => {
    const res = await axios.get(`${configData.SERVER_ADMIN_URL}/products/${localStorage.getItem('eshopBranchID')}`);
    setProducts(res.data || []);
  };

  const loadCategories = async () => {
    const res = await axios.get(configData.SERVER_ADMIN_URL + "/cat");
    setCategories(res.data || []);
  };

  const loadSubcategories = async () => {
    const res = await axios.get(configData.SERVER_ADMIN_URL + "/subcat");
    setSubcategories(res.data || []);
  };

  useEffect(() => {
    loadProducts();
    loadCategories();
    loadSubcategories();
  }, []);

  // 🧾 Handle input
  const handleChange = (e) => {
    const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    setFormData((prev) => ({...prev,[name]: value,}));
  };

  // ➕ New Product
  const handleNew = () => {
    setFormData({
      ProductName: "",
      proSize: "",
      category: "",
      CategoryID: "",
      subCategory: "",
      ProductPrice: "",
      mUnit: "",
      UnitsInStock: 0,
      Description: "",
      ManufactureYear: "",
      origin: "",
      ColorCode: "",
      Feature:"",
      status:"A"
    });
    setEditingId(null);
    setView("form");
  };

  // ✏️ Edit Product
  const handleEdit = (product) => {
    setFormData(product);
    setEditingId(product.ProductID);
    setView("form");
  };

  // 💾 Save
  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(formData);

    try {
      if (editingId) {
        let res=await axios.put(`${configData.SERVER_ADMIN_URL}/products/${editingId}`,formData);
        if(res.data.success){
            alert("Updated successfully");
        } else alert('Update Error');
      } else {
        let response= await axios.post(`${configData.SERVER_ADMIN_URL}/products/${localStorage.getItem('eshopBranchID')}`,formData);
        if(response.data.success){
            alert("Add successfully");
        } else alert('Insertion Error');
      }

      setView("list");
      loadProducts();

    } catch (err) {
      console.error(err);
      alert("Error saving");
    }
  };

// Select File
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // Upload File
  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file");
      return;
    }
    setLoading(true);

    const formDataFile = new FormData();
    formDataFile.append("file", selectedFile);

    try {
      const res = await axios.post(`${configData.SERVER_ADMIN_URL}/upload/${editingId}`,formDataFile,
        {
          headers: { "Content-Type": "multipart/form-data",},
        }
      );

      if(res.data.success){
      setMessage(res.data.message);
      setFormData(prev => ({ ...prev, Image: res.data.file.filename,}));
      setProducts((prev) =>
        prev.map((item) =>
          item.ProductID === formData.ProductID
          ? { ...item, Image: res.data.file.filename }: item
        )
      );
      }
    } catch (error) {
      console.error(error);
      setMessage("Upload failed");
      } finally {
      setLoading(false);
      }
  };

  return (
    <>
      <Navbar />

      <div className="container my-4">
        <div className="card card-body">

        {/* 🔹 LIST VIEW */}
        {view === "list" && (
          <>
            <div className="d-flex justify-content-between mb-3">
              <h3>Product List</h3>
              <button className="btn btn-success" onClick={handleNew}>
                + New Product
              </button>
            </div>

            <table className="table table-bordered">
              <thead className="table-dark">
                <tr>
                    <th>Product Name</th>
                    <th>Description</th>
                    <th>Price</th>
                    <th>Stock</th>
                    <th>Feature Products</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {products.map((p) => (
                  <tr key={p.ProductID}>
                    <td>
                      <img className="img-fluid img-thumbnail"
                        src={configData.IMAGE_URL +"/products/" + p.Image} alt={p.ProductName}
                        style={{ maxWidth: "100px", maxHeight: "75px", objectFit: "contain", }}
                      /> 
                      <br></br>{p.ProductName}
                    </td>
                    <td>{p.Description}</td>
                    <td>{p.ProductPrice}</td>
                    <td>{p.UnitsInStock}</td>
                    <td>{p.Feature}</td>
                    <td>{p.status}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleEdit(p)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* 🔹 FORM VIEW */}
        {view === "form" && (
          <>
            <div className="mb-3">
            <button className="btn btn-secondary" onClick={() => setView("list")}>
              ← Back to List
            </button>
            </div>

            <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
                <div className="row well">

                <div className="col-lg-6 col-md-6 mb-3">
                <label>Category</label>
                <select className="form-control" name="CategoryID" value={formData.CategoryID} onChange={handleChange} required>
                    <option value="">---</option>
                    {categories.map((category) => (
                        <option key={category.CategoryID} value={category.CategoryID}>
                        {category.CategoryName}
                        </option>
                    ))}
                </select>
                </div>

                <div className="col-lg-6 col-md-6  mb-3">
                <label>Sub-Category</label>
                <select className="form-control" name="subCategory" value={formData.subCategory} onChange={handleChange} required>
                    <option value="">---</option>
                    {subcategories.map((subcategory, index) => (
                        <option key={index} value={subcategory.subCategoryName}>
                        {subcategory.subCategoryName}
                        </option>
                    ))}
                </select>
                </div>

                <div className="col-lg-6 col-md-6  mb-3">
                    <label>Product Name</label>
                    <input name="ProductName" value={formData.ProductName} onChange={handleChange} className="form-control" required />
                </div>
                <div className="col-lg-6 col-md-6  mb-3">
                    <label>Product Size</label>
                    <input name="proSize" value={formData.proSize} onChange={handleChange} className="form-control" />
                </div>
                <div className="mb-3">
                    <label>Description (Use ; for string seperation)</label>
                    <textarea name="Description" value={formData.Description} onChange={handleChange} className="form-control" rows={4}></textarea>
                </div>
                <div className="col-lg-3 col-md-3 mb-3">
                    <label>Price</label>
                    <input type="number" name="ProductPrice" value={formData.ProductPrice} onChange={handleChange} className="form-control" required />
                </div>
                <div className="col-lg-3 col-md-3 mb-3">
                    <label>Unit</label>
                    <select name="mUnit" value={formData.mUnit} onChange={handleChange} className="form-control">
                        {units.map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                </div>

                <div className="col-lg-3 col-md-3 mb-3">
                    <label>Stock</label>
                    <input type="number" name="UnitsInStock" value={formData.UnitsInStock} onChange={handleChange} className="form-control" />
                </div>

                <div className="col-lg-3 col-md-3 mb-3">
                    <label>Year of Manufacture</label>
                    <input type="number" name="ManufactureYear" value={formData.ManufactureYear} onChange={handleChange} className="form-control" />
                </div>

                <div className="col-lg-3 col-md-3 mb-3">
                    <label>Origin</label>
                    <input type="text" name="origin" value={formData.origin} onChange={handleChange} className="form-control" />
                </div>

                <div className="col-lg-3 col-md-3 mb-3">
                    <label>Feature Product</label>
                    <select name="Feature" value={formData.Feature} onChange={handleChange} className="form-control">
                        <option value='1'>Y</option>
                        <option value='0'>N</option>
                    </select>
                </div>

                <div className="col-lg-3 col-md-3 mb-3">
                    <label>Status</label>
                    <select name="status" value={formData.status} onChange={handleChange} className="form-control">
                        <option value='A'>Active</option>
                        <option value='I'>In-Active</option>
                    </select>
                </div>

                <div className="mb-3">
                <button className="btn btn-primary col-lg-3 col-md-3 mt-3">
                {editingId ? "Update" : "Save"}
                </button>
                </div>
                
                </div>
            </form>

            <hr/>
            {editingId ?
            <div className="row g-4 align-items-start">
              {/* UPLOAD SECTION */}
              <div className="col-lg-6 col-md-6">
                <div className="card shadow-sm border-0">   
                  <div className="card-body">
                    <h5 className="mb-3">Product Image Upload</h5>

                    <label className="form-label">Select Image</label>
                    <input className="form-control mb-3" type="file" onChange={handleFileChange}/>

                    <button className="btn btn-primary w-100" onClick={handleUpload} disabled={loading}>
                    {loading ? "Uploading..." : "Upload Image"}
                    </button>

                    {message && (
                    <div className={`alert mt-3 ${ message.toLowerCase().includes("success")  ? "alert-success" : "alert-danger" }`}>
                    {message}
                    </div>
                    )}
                  </div>
                </div>
              </div>

              {/* PREVIEW SECTION */}
              <div className="col-lg-6 col-md-6">
                <div className="card shadow-sm border-0 text-center">
                  <div className="card-body">
                    <h5 className="mb-3">Current Product Image</h5>
                    <div style={{ width: "100%",height: "250px",display: "flex",justifyContent: "center",}} >
                      <img
                        src={ formData.Image 
                          ? `${configData.IMAGE_URL}/products/${formData.Image}?t=${new Date().getTime()}`
                          : ""} 
                          alt="Product" style={{ maxWidth: "300px", maxHeight: "250px", objectFit: "contain", }}
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
            :""
            }

          </>
        )}

        </div>
      </div>

      <Footer />
    </>
  );
};

export default AddProducts;